<template>
    <q-icon
      :name="icon"
      :title="socialSite.name"
      :class="cssClass"
      v-bind="$attrs"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { types } from '@/social/site/index';
import { SocialSite } from '@/type';

const map:{[socialSiteType: string]: string} = {};
map[types.Twitter] = 'x-twitter';
map[types.Facebook] = 'facebook';
map[types.Instagram] = 'instagram';
map[types.YouTube] = 'youtube';
map[types.TikTok] = 'tiktok';

export default defineComponent({
  props: {
    socialSite: {
      type: Object as () => SocialSite,
      required: true,
    },
    color: String,
  },
  computed: {
    icon(): string {
      return `fab fa-${map[this.socialSite.type]}`;
    },
    actualColor(): string {
      return this.color || this.socialSite.type.toLowerCase();
    },
    cssClass(): string {
      return `text-${this.actualColor}`;
    },
  },
});
</script>
